$(() => {
  const setText = (selector, val) => $(selector).text(val === '0' ? '' : val);
  $(window).on('storage', ({ originalEvent: { key, newValue } }) => {
    if (key === 'menuJobBadgeCount') {
      setText('[data-menu-job-badge]', newValue);
    }

    if (key === 'negotiationTotalBadgeCount') {
      setText('[data-negotiation-total-badge]', newValue);
    }

    const m = /negotiation([0-9]+)BadgeCount/.exec(key);
    if (m) {
      setText(
        `[data-negotiation-badge][data-negotiation-id=${m[1]}]`,
        newValue
      );
    }
  });
});
